<template>
  <div>
    <div class="view-title clearfix">
      <span>{{$t('T_RESULT_THROW_DISTANCE_INFORMATION')}}</span>
    </div>
    <div class="card-info" v-if="!isUSTWall && !isSimple">
          <ul v-if="position === 0 && ((this.vAngleFlag && this.vAngle !== 0) || (this.hAngleFlag && this.hAngle !== 0))" class="info-ul">
            <li class="projector_text result_brightnessguide-position-title">
              <span>{{$t('T_RESULT_PROJECTOR_POSITION')}}</span>
            </li>
            <li>
              <!-- =SimPH -->
              (1) {{$t('T_RESULT_FLOOR_TO_LENS_HEIGHT')}}{{floor2Projector + ' ' +unitLabel}}
            </li>
            <li>
              <!-- =TH -->
              (2) {{$t('T_RESULT_SCREEN_TO_LENS_DISTANCE')}}{{pjYData + ' ' + unitLabel}}
            </li>
            <li>
              <!-- =RH-(SH+SB) -->
              (3) {{$t('T_RESULTCEILING_TO_TOP_HEIGHT')}}{{floor2topCpmuted}}
            </li>
            <li>
              <!-- =SB -->
              (4) {{$t('T_RESULT_FLOOR_TO_BOTTOM')}}{{floor2bottomCpmuted}}
            </li>
            <li>
              <!-- =SW,=SH -->
              (5) {{$t('T_RESULT_WIDE_X_HEIGHT_SCREEN_SIZE')}}{{scrnW_H}}
            </li>
            <li>
              <!-- =SD -->
              (6) {{$t('T_RESULT_DIAGONAL_INCH_SCREEN_SIZE')}}{{screenSizeComputed}}
            </li>
            <li>
              <!-- =Angle (Vertical) -->
              (7) {{$t('T_RESULT_PROJECTOR_ANGLE_V')}}{{vAngleData}}
            </li>
            <li>
              <!-- =Angle (Rotation && Horizontal) -->
              (8) {{$t('T_RESULT_PROJECTOR_ANGLE_R_KEYSTONE')}}{{hAngleData}}
            </li>
            <!-- <li v-for="(item, index) in FangleData" :key="index">
              <span>{{'(' + (index + 1) + ')'}}</span>
              <span>{{$t(item.title)}}</span>
              <span>{{item.value}}</span>
            </li> -->
          </ul>
          <ul v-else-if="position === 0 && this.$store.state.selectedModelData.lensExchange && this.selectedLensData.id.indexOf('LX') > -1" class="info-ul">
            <li class="projector_text result_brightnessguide-position-title">
              <span>{{$t('T_RESULT_PROJECTOR_POSITION')}}</span>
            </li>
            <li>
              <!-- =SimPH-FE -->
              (1) {{$t('T_RESULT_FLOOR_TO_FOOT_OF_PROJECTOR_HEIGHT')}}
              <span :class="isNegativeNum ? 'negative_num_color' : ''">{{floor2footProjector}}</span>
            </li>
            <li>
              <!-- =ABS((SimPH-FE)-SB) -->
              (2) {{$t('T_RESULT_BOTTOM_OF_SCREEN_TO_FOOT_OF_PROJECTOR_HEIGHT')}}{{bottom2FootProjector}}
            </li>
            <li>
              <!-- =TH -->
              (3) {{$t('T_RESULT_SCREEN_TO_LENS_DISTANCE')}}{{pjYData + ' ' + unitLabel}}
            </li>
            <li>
              <!-- =TH-LX -->
              (4) {{$t('T_RESULT_SCREEN_TO_PROJECTOR')}}{{screen2projector}}
            </li>
            <li>
              <!-- =RH-(SH+SB) -->
              (5) {{$t('T_RESULTCEILING_TO_TOP_HEIGHT')}}{{floor2topCpmuted}}
            </li>
            <li>
              <!-- =SB -->
              (6) {{$t('T_RESULT_FLOOR_TO_BOTTOM')}}{{floor2bottomCpmuted}}
            </li>
            <li>
              <!-- =SW,=SH -->
              (7) {{$t('T_RESULT_WIDE_X_HEIGHT_SCREEN_SIZE')}}{{scrnW_H}}
            </li>
            <li>
              <!-- =SD -->
              (8) {{$t('T_RESULT_DIAGONAL_INCH_SCREEN_SIZE')}}{{screenSizeComputed}}
            </li>
          </ul>
          <ul v-else v-show="position === 0 ? true : false" class="info-ul">
            <li class="projector_text result_brightnessguide-position-title">
              <span>{{$t('T_RESULT_PROJECTOR_POSITION')}}</span>
            </li>
            <li>
              <!-- =SimPH-FE -->
              (1) {{$t('T_RESULT_FLOOR_TO_LENS_HEIGHT')}}
              <span :class="isNegativeNum ? 'negative_num_color' : ''">{{floor2footProjector}}</span>
            </li>
            <li>
              <!-- =ABS((SimPH-FE)-SB) -->
              (2) {{$t('T_RESULT_BOTTOM_OF_SCREEN_TO_FOOT_OF_PROJECTOR_HEIGHT')}}{{bottom2FootProjector}}
            </li>
            <li>
              <!-- =TH -->
              (3) {{$t('T_RESULT_SCREEN_TO_LENS_DISTANCE')}}{{pjYData + ' ' + unitLabel}}
            </li>
            <li>
              <!-- =RH-(SH+SB) -->
              (4) {{$t('T_RESULTCEILING_TO_TOP_HEIGHT')}}{{floor2topCpmuted}}
            </li>
            <li>
              <!-- =SB -->
              (5) {{$t('T_RESULT_FLOOR_TO_BOTTOM')}}{{floor2bottomCpmuted}}
            </li>
            <li>
              <!-- =SW,=SH -->
              (6) {{$t('T_RESULT_WIDE_X_HEIGHT_SCREEN_SIZE')}}{{scrnW_H}}
            </li>
            <li>
              <!-- =SD -->
              (7) {{$t('T_RESULT_DIAGONAL_INCH_SCREEN_SIZE')}}{{screenSizeComputed}}
            </li>
          </ul>
          <ul v-if="position !== 0 && ((this.vAngleFlag && this.vAngle !== 0) || (this.hAngleFlag && this.hAngle !== 0))" class="info-ul">
            <li class="projector_text result_brightnessguide-position-title">
              <span>{{$t('T_RESULT_PROJECTOR_POSITION')}}</span>
            </li>
            <li>
              <!-- =RH-SimPH -->
              (1) {{$t('T_RESULT_CEILING_TO_LENS')}}{{floor2Projector + ' ' +unitLabel}}
            </li>
            <li>
              <!-- =TH -->
              (2) {{$t('T_RESULT_SCREEN_TO_LENS_DISTANCE')}}{{pjYData + ' ' + unitLabel}}
            </li>
            <li>
              <!-- =RH-(SH+SB) -->
              (3) {{$t('T_RESULTCEILING_TO_TOP_HEIGHT')}}{{floor2topCpmuted}}
            </li>
            <li>
              <!-- =SB -->
              (4) {{$t('T_RESULT_FLOOR_TO_BOTTOM')}}{{floor2bottomCpmuted}}
            </li>
            <li>
              <!-- =SW,=SH -->
              (5) {{$t('T_RESULT_WIDE_X_HEIGHT_SCREEN_SIZE')}}{{scrnW_H}}
            </li>
            <li>
              <!-- =SD -->
              (6) {{$t('T_RESULT_DIAGONAL_INCH_SCREEN_SIZE')}}{{screenSizeComputed}}
            </li>
            <li>
              <!-- =Angle (Vertical) -->
              (7) {{$t('T_RESULT_PROJECTOR_ANGLE_V_KEYSTONE')}}{{vAngleData}}
            </li>
            <li>
              <!-- =Angle (Rotation && Horizontal) -->
              (8) {{$t('T_RESULT_PROJECTOR_ANGLE_R_KEYSTONE')}}{{hAngleData}}
            </li>
          </ul>
          <ul v-else-if="position !== 0 && this.$store.state.selectedModelData.lensExchange && this.selectedLensData.id.indexOf('LX') > -1" class="info-ul">
            <li class="projector_text result_brightnessguide-position-title">
              <span>{{$t('T_RESULT_PROJECTOR_POSITION')}}</span>
            </li>
            <li>
              <!-- =RH-(SimPH+CC+MU) -->
              (1) {{$t('T_RESULT_CEILING_TO_BOTTOM_HEIGHT')}}{{ceiling2topLx}}
            </li>
            <li>
              <!-- =ABS((SimPH+CC+MU)-(SH+SB)) -->
              (2) {{$t('T_RESULT_SCREEN_TO_BOTTOM_HEIGHT')}}{{top2bottomProjectorLx}}
            </li>
            <li>
              <!-- =SimPH+CC-UP -->
              (3) {{$t('T_RESULT_FLOOR_TO_UPPER_HEIGHT')}}{{floor2upperProjectorLx}}
            </li>
            <li>
              <!-- =TH -->
              (4) {{$t('T_RESULT_SCREEN_TO_LENS_DISTANCE')}}{{pjYData + ' ' + unitLabel}}
            </li>
            <li>
              <!-- =TH-LX -->
              (5) {{$t('T_RESULT_SCREEN_TO_PROJECTOR_DISTANCE')}}{{screen2projector}}
            </li>
            <li>
              <!-- =RH-(SH+SB) -->
              (6) {{$t('T_RESULTCEILING_TO_TOP_HEIGHT')}}{{floor2topCpmuted}}
            </li>
            <li>
              <!-- =SB -->
              (7) {{$t('T_RESULT_FLOOR_TO_BOTTOM')}}{{floor2bottomCpmuted}}
            </li>
            <li>
              <!-- =SW,=SH -->
              (8) {{$t('T_RESULT_WIDE_X_HEIGHT_SCREEN_SIZE')}}{{scrnW_H}}
            </li>
            <li>
              <!-- =SD -->
              (9) {{$t('T_RESULT_DIAGONAL_INCH_SCREEN_SIZE')}}{{screenSizeComputed}}
            </li>
          </ul>
          <ul v-else v-show="position !== 0 ? true : false" class="info-ul">
            <li class="projector_text result_brightnessguide-position-title">
              <span>{{$t('T_RESULT_PROJECTOR_POSITION')}}</span>
            </li>
            <li>
              <!-- =RH-(SimPH+MU) -->
              (1) {{$t('T_RESULT_CEILING_TO_BOTTOM_HEIGHT')}}{{ceiling2top}}
            </li>
            <li>
              <!-- =ABS((SimPH+MU)-(SH+SB)) -->
              (2) {{$t('T_RESULT_SCREEN_TO_BOTTOM_HEIGHT')}}{{top2bottomProjector}}
            </li>
            <li>
              <!-- =SimPH-UP -->
              (3) {{$t('T_RESULT_FLOOR_TO_UPPER_HEIGHT')}}{{floor2upperProjector}}
            </li>
            <li>
              <!-- =TH -->
              (4) {{$t('T_RESULT_SCREEN_TO_LENS_DISTANCE')}}{{pjYData + ' ' + unitLabel}}
            </li>
            <li>
              <!-- =RH-(SH+SB) -->
              (5) {{$t('T_RESULTCEILING_TO_TOP_HEIGHT')}}{{floor2topCpmuted}}
            </li>
            <li>
              <!-- =SB -->
              (6) {{$t('T_RESULT_FLOOR_TO_BOTTOM')}}{{floor2bottomCpmuted}}
            </li>
            <li>
              <!-- =SW,=SH -->
              (7) {{$t('T_RESULT_WIDE_X_HEIGHT_SCREEN_SIZE')}}{{scrnW_H}}
            </li>
            <li>
              <!-- =SD -->
              (8) {{$t('T_RESULT_DIAGONAL_INCH_SCREEN_SIZE')}}{{screenSizeComputed}}
            </li>
          </ul>
      <ul class="info-ul info-ul-dot" v-if="!isSimple">
        <li class="projector_text result_brightnessguide-position-title">
          <span>{{$t('T_RESULT_PROJECTOR_SETTING')}}</span>
        </li>
        <li>
          {{$t('T_RESULT_LENS_SHIFT_V')}}{{vLensShiftNowData}}
        </li>
        <li>
          {{$t('T_RESULT_LENS_SHIFT_H')}}{{hLensShiftNowData}}
        </li>
        <li>
          {{$t('T_RESULT_KEYSTONE_CORRECTION_V')}}{{$t(keyStoneVerticalShow)}}
        </li>
        <li>
          {{$t('T_RESULT_KEYSTONE_CORRECTION_H')}}{{$t(keyStoneHorizontalShow)}}
        </li>
      </ul>
      <div class="information-right" :class="classValue()" v-if="!isSimple"></div>
    </div>
    <div class="card-info" v-else-if="isUSTWall">
      <ul class="ust-info-ul">
        <li>(1) {{$t('T_WALL_TO_PJ_DISTANCE') + ': '}}{{wallToPJ + ' ' + unitLabel}}</li>
        <li>(2) {{$t('T_SCREEN_SIZE') + ': '}}{{screenSizeComputed}}</li>
        <li>(3) {{$t('T_WALLPLATE_TO_CEILING_HEIGHT') + ': '}}{{plateTopToCeiling + ' ' + unitLabel}}</li>
        <li>(4) {{$t('T_WALLPLATE_TO_SCREEN_HEIGHT') + ': '}}{{plateBottomToScreen + ' ' + unitLabel}}</li>
        <li>(5) {{$t('T_SCREEN_TOP_TO_CEILING_HEIGHT') + ': '}}{{screenTopToCeiling + ' ' + unitLabel}}</li>
      </ul>
      <div class="information-right">
        <img class="ust-information-right" :src="require('@/assets/parts/UST/' + frontWallUrl + '.png')"/>
      </div>
    </div>
    <div class="card-info" v-else>
      <ul class="ust-info-ul">
        <li>(1) {{$t('T_RESULT_FLOOR_TO_FOOT_OF_PROJECTOR_HEIGHT')}}
          <span :class="isNegativeNum ? 'negative_num_color' : ''">{{floor2footProjector}}</span>
        </li>
        <li>(2) {{$t('T_RESULT_FLOOR_TO_BOTTOM')}}{{floor2bottomCpmuted}}</li>
        <li>(3) {{$t('T_RESULTCEILING_TO_TOP_HEIGHT')}}{{floor2topCpmuted}}</li>
        <li>(4) {{$t('T_RESULT_DIAGONAL_INCH_SCREEN_SIZE')}}{{screenSizeComputed}}</li>
        <li>(5) {{$t('T_RESULT_WIDE_X_HEIGHT_SCREEN_SIZE')}}{{scrnW_H}}</li>
        <li>(6) {{$t('T_RESULT_SCREEN_TO_LENS_DISTANCE')}}{{pjYData + ' ' + unitLabel}}</li>
      </ul>
    </div>
  </div>
  </template>
  <script type="text/javascript">
  import { mapState, mapGetters, mapMutations } from 'vuex'
  export default {
    name: 'resultInformation',
    data () {
      return {
        dialogVisible: false,
        reportTopTableInfo: [],
        projectorPosition: [],
        projectorSetting: [],
        relativeBasePointer: '',
        isNegativeNum: false
      }
    },
    methods: {
      ...mapMutations([
        'SET_KEYSTONEVERTICAL', 'SET_KEYSTONEHORIZONTAL', 'SET_USTLENSTOFRONTPJ'
      ]),
      // // 复制
      // copy () {
      //   var clipboard = new Clipboard('.copy')
      //   clipboard.on('success', e => {
      //     alert('复制成功')
      //     // 释放内存
      //     clipboard.destroy()
      //     console.log(this.projectorPosition)
      //   })
      //   clipboard.on('error', e => {
      //     // 不支持复制
      //     alert('该浏览器不支持自动复制')
      //     // 释放内存
      //     clipboard.destroy()
      //   })
      // },
  
      // saveAsPdf () {
      //   // 手动创建一个 canvas 标签
      //   const canvas = document.createElement('canvas')
      //   // 获取父标签，意思是这个标签内的 DOM 元素生成图片
      //   let canvasBox = document.getElementById('resultReport')
      //   // 获取父级的宽高
      //   const width = parseInt(window.getComputedStyle(canvasBox).width)
      //   const height = parseInt(window.getComputedStyle(canvasBox).height)
      //   // 宽高 * 2 并放大 2 倍 是为了防止图片模糊
      //   canvas.width = width * 2
      //   canvas.height = height * 2
      //   canvas.style.width = width + 'px'
      //   canvas.style.height = height + 'px'
      //   const context = canvas.getContext('2d')
      //   context.scale(2, 2)
      //   const options = {
      //     backgroundColor: null,
      //     canvas: canvas,
      //     useCORS: true,
      //     y: 0,
      //     x: 0,
      //     scrollX: document.getElementById('resultReport-dialog').scrollLeft - (document.getElementById('resultReport-dialog').children[0].offsetLeft + document.getElementById('resultReport').offsetLeft),
      //     scrollY: document.getElementById('resultReport-dialog').scrollTop - (document.getElementById('resultReport-dialog').children[0].offsetTop + document.getElementById('resultReport').offsetTop),
      //     windowHeight: window.innerHeight,
      //     windowWidth: window.innerWidth
      //   }
      //   html2canvas(canvasBox, options).then((canvas) => {
      //     // toDataURL 图片格式转成 base64
      //     let imgData = canvas.toDataURL('image/png')
      //     var img = new Image()
      //     img.src = imgData
      //     var imgWidth = 595.28
      //     var imgHeight = 592.28 / (canvas.width * 0.5) * (canvas.height * 0.5)
      //     img.onload = function () {
      //       var doc = new JsPDF('', 'pt', 'a4')
      //       doc.addImage(imgData, 'jpeg', 0, 0, imgWidth, imgHeight)
      //       doc.save('pdf_' + new Date().getTime() + '.pdf')
      //     }
      //   })
      // },
  
      openCancelAction () {
        if (!this.dialogVisible) {
          this.formatReportTopTableInfo()
          this.formatReportInfo()
        }
        this.dialogVisible = !this.dialogVisible
      },
  
      formatReportTopTableInfo () {
        this.reportTopTableInfo = []
        let tempObj = this.$store.state.selectedModelData
        this.reportTopTableInfo.push({
          title: 'T_INFO_BRIGHTNESS',
          value: tempObj.color
        })
        this.reportTopTableInfo.push({
          title: 'T_INFO_RESOLUTION',
          value: tempObj.resolution
        })
        this.reportTopTableInfo.push({
          title: 'LCD_PANEL_SIZE',
          value: tempObj.lcdSize + 'inch'
        })
        this.reportTopTableInfo.push({
          title: 'POWER_SUPPLY',
          value: tempObj.supplyVoltage
        })
        this.reportTopTableInfo.push({
          title: 'T_INFO_POWER_CONSUMPTION',
          // value: tempObj.consumption220 + '/' + tempObj.consumption220_eco
          value: tempObj.consumption220
        })
      },
  
      formatReportInfo () {
        this.projectorPosition = []
        this.projectorSetting = []
        this.projectorPosition.push({
          title: 'T_THROW_DISTANCE_INFORMATION',
          value: this.pjYData + this.unitLabel
        })
        this.projectorPosition.push({
          title: 'T_FROM_FLIIR_TO_PROJECTOR',
          value: this.floor2Projector + this.unitLabel
        })
        this.projectorPosition.push({
          title: 'T_FROM_BASE_POINT_TO_PROJECTOR',
          value: this.relativeBasePointer
        })
        this.projectorPosition.push({
          title: 'T_PROJECTOR_ANGLE_V',
          value: this.vAngleData
        })
        this.projectorPosition.push({
          title: 'T_PROJECTOR_ANGLE_H',
          value: this.hAngleData
        })
        this.projectorSetting.push({
          title: 'T_LENS_SHIFT_V',
          value: this.vLensShiftNowData
        })
        this.projectorSetting.push({
          title: 'T_LENS_SHIFT_H',
          value: this.hLensShiftNowData
        })
        this.projectorSetting.push({
          title: 'T_KEYSTONE_CORRECTION_V',
          value: this.$t(this.keyStoneVerticalShow)
        })
        this.projectorSetting.push({
          title: 'T_KEYSTONE_CORRECTION_H',
          value: this.$t(this.keyStoneHorizontalShow)
        })
        /* this.projectorSetting.push({
          title: 'T_CURVED_SURFACE_CORRECTION',
          value: ''
        }) */
      },
  
      initReport () {
        this.$refs.resultReport.initCanvas()
      },
  
      getRelativeBasePointer (value) {
        let screenPointer0 = this.drawData[0][0] || {}
        return 'X: ' + this.$commonJs.changeUnit(value.pjX - screenPointer0.x, this.graph.unit) + this.unitLabel + ', Y: ' + this.$commonJs.changeUnit(value.pjY, this.graph.unit) + this.unitLabel + ', Z: ' + this.$commonJs.changeUnit(value.pjZ - screenPointer0.z, this.graph.unit) + this.unitLabel
      },
  
      classValue () {
        if (this.position === 0) {
          if ((this.vAngleFlag && this.vAngle !== 0) || (this.hAngleFlag && this.hAngle !== 0)) {
            if (this.$store.state.selectedModelData.lensExchange && this.selectedLensData.id.indexOf('LX') > -1) {
              return 'information-right-desk-lx-angle'
            } else {
              return 'information-right-desk-angle'
            }
          } else {
            if (this.$store.state.selectedModelData.lensExchange && this.selectedLensData.id.indexOf('LX') > -1) {
              return 'information-right-desk-lx'
            } else {
              return 'information-right-desk'
            }
          }
        } else {
          if ((this.vAngleFlag && this.vAngle !== 0) || (this.hAngleFlag && this.hAngle !== 0)) {
            if (this.$store.state.selectedModelData.lensExchange && this.selectedLensData.id.indexOf('LX') > -1) {
              return 'information-right-ceil-lx-angle'
            } else {
              return 'information-right-ceil-angle'
            }
          } else {
            if (this.$store.state.selectedModelData.lensExchange && this.selectedLensData.id.indexOf('LX') > -1) {
              return 'information-right-ceil-lx'
            } else {
              return 'information-right-ceil'
            }
          }
        }
      }
    },
  
    mounted () {
      this.relativeBasePointer = this.getRelativeBasePointer(this.graph)
    },
  
    filters: {
      filterKeyStone (value) {
        return value === 1 ? 'Available' : 'Not Available'
      }
    },
  
    computed: {
      ...mapState([
        'graph',
        'vLensShift',
        'hLensShift',
        'vAngleFlag',
        'vAngle',
        'hAngleFlag',
        'hAngle',
        'selectedModelData',
        'selectedLensData',
        'drawData',
        'houseInfo',
        'vLensShiftNow',
        'hLensShiftNow',
        'floor2bottom',
        'screenSize',
        'position',
        'dashFlag',
        'isUSTWall',
        'plateTopToCeiling',
        'screenTopToCeiling',
        'plateBottomToScreen',
        'isLatvia',
        'offset',
        'isSimple'
      ]),
  
      ...mapGetters([
        'unitLabel'
      ]),
  
      pjYData () {
        return this.$commonJs.changeUnit(this.graph.pjY, this.graph.unit)
      },
      wallToPJ () {
        let value = this.ProjectorLensSpec.find(item => this.selectedModelData.code === item.code)
        let lx = value.lx > 0 ? value.lx / 10 : value.lx / 10 * (-1)
        this.SET_USTLENSTOFRONTPJ(lx)
        return this.$commonJs.changeUnit(this.graph.pjY - lx + this.offset, this.graph.unit, false, true)
      },
      scrnW_H () {
        let scrnW = this.$commonJs.changeUnit(this.graph.scrnW, this.graph.unit)
        let scrnH = this.$commonJs.changeUnit(this.graph.scrnH, this.graph.unit)
        if ((this.vAngleFlag && this.vAngle !== 0) || (this.hAngleFlag && this.hAngle !== 0)) {
          if (this.dashFlag) {
            return scrnW + ' x ' + scrnH + ' ' + this.unitLabel
          } else {
            return '-'
          }
        } else {
          return scrnW + ' x ' + scrnH + ' ' + this.unitLabel
        }
      },
  
      floor2Projector () {
        let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
        if (this.position === 0) {
          return this.$commonJs.changeUnit(f2l, this.graph.unit)
        } else {
          return this.$commonJs.changeUnit(this.houseInfo.roomH - f2l, this.graph.unit)
        }
      },
  
      keyStoneVertical () {
        let data = this.vAngleFlag ? this.hAngleFlag ? 0 : this.vAngle >= this.keyStoneRangleV.min && this.vAngle <= this.keyStoneRangleV.max ? 1 : 0 : 1
        this.SET_KEYSTONEVERTICAL(data)
        return data
      },
  
      keyStoneVerticalShow () {
        return this.keyStoneVertical === 1 ? 'T_RESULT_CAN_BE_CORRECTED' : 'T_RESULT_EXCEEDED_KEYSTONE_CORRECTION'
      },
  
      keyStoneHorizontal () {
        let data = this.hAngleFlag ? this.vAngleFlag ? 0 : this.hAngle >= this.keyStoneRangleH.min && this.hAngle <= this.keyStoneRangleH.max ? 1 : 0 : 1
        this.SET_KEYSTONEHORIZONTAL(data)
        return data
      },
  
      keyStoneHorizontalShow () {
        return this.keyStoneHorizontal === 1 ? 'T_RESULT_CAN_BE_CORRECTED' : 'T_RESULT_EXCEEDED_KEYSTONE_CORRECTION'
      },
  
      keyStoneRangleV () {
        let data = this.selectedModelData
        return { 'min': data.keystoneVMin, 'max': data.keystoneVMax }
      },
  
      keyStoneRangleH () {
        let data = this.selectedModelData
        return { 'min': data.keystoneHMin, 'max': data.keystoneHMax }
      },
  
      vAngleData () {
        return (this.vAngleFlag ? this.vAngle : 0) + '°'
      },
  
      hAngleData () {
        return (this.hAngleFlag ? this.hAngle : 0) + '°'
      },
  
      floor2topCpmuted () {
        if (this.drawData) {
          let textName2 = this.drawData[0][3].z - this.drawData[0][0].z
          let f2top = this.houseInfo.roomH - (this.graph.scrnH + this.floor2bottom) + (this.graph.scrnH - textName2)
          return this.$commonJs.changeUnit(f2top > 0 ? f2top : 0, this.graph.unit) + ' ' + this.unitLabel
        }
        return null
      },
  
      screen2projector () {
        let BrightnessDataLx = this.getBrightnessLx
        if (this.selectedModelData.lensExchange === true) {
          let s2projector = this.graph.pjY - BrightnessDataLx
          return this.$commonJs.changeUnit(s2projector, this.graph.unit) + ' ' + this.unitLabel
        } else {
          let s2projector = this.graph.pjY - this.selectedLensData.lx
          return this.$commonJs.changeUnit(s2projector, this.graph.unit) + ' ' + this.unitLabel
        }
      },
  
      floor2upperProjector () {
        let BrightnessDataUp = this.getBrightnessUp
        let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
        if (this.selectedModelData.lensExchange === true) {
          let f2upper = f2l - BrightnessDataUp
          return this.$commonJs.changeUnit(f2upper > 0 ? f2upper : 0, this.graph.unit) + ' ' + this.unitLabel
        } else {
          let f2upper = f2l - this.selectedLensData.up
          return this.$commonJs.changeUnit(f2upper > 0 ? f2upper : 0, this.graph.unit) + ' ' + this.unitLabel
        }
      },
  
      floor2upperProjectorLx () {
        let BrightnessDataUp = this.getBrightnessUp
        let BrightnessDataCc = this.getBrightnessCc
        let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
        if (this.selectedModelData.lensExchange === true) {
          let f2upperlx = f2l + BrightnessDataCc - BrightnessDataUp
          return this.$commonJs.changeUnit(f2upperlx, this.graph.unit) + ' ' + this.unitLabel
        } else {
          let f2upperlx = f2l + BrightnessDataCc - this.selectedLensData.up
          return this.$commonJs.changeUnit(f2upperlx, this.graph.unit) + ' ' + this.unitLabel
        }
      },
  
      ceiling2top () {
        let BrightnessDataMu = this.getBrightnessMu
        let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
        if (this.selectedModelData.lensExchange === true) {
          let c2top = this.houseInfo.roomH - (f2l + BrightnessDataMu)
          return this.$commonJs.changeUnit(c2top > 0 ? c2top : 0, this.graph.unit) + ' ' + this.unitLabel
        } else {
          let c2top = this.houseInfo.roomH - (f2l + this.selectedLensData.mu)
          return this.$commonJs.changeUnit(c2top > 0 ? c2top : 0, this.graph.unit) + ' ' + this.unitLabel
        }
      },
  
      ceiling2topLx () {
        let BrightnessDataCc = this.getBrightnessCc
        let BrightnessDataMu = this.getBrightnessMu
        let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
        if (this.selectedModelData.lensExchange === true) {
          let c2toplx = this.houseInfo.roomH - (f2l + BrightnessDataCc + BrightnessDataMu)
          return this.$commonJs.changeUnit(c2toplx > 0 ? c2toplx : 0, this.graph.unit) + ' ' + this.unitLabel
        } else {
          let c2toplx = this.houseInfo.roomH - (f2l + BrightnessDataCc + this.selectedLensData.mu)
          return this.$commonJs.changeUnit(c2toplx > 0 ? c2toplx : 0, this.graph.unit) + ' ' + this.unitLabel
        }
      },
  
      floor2footProjector () {
        let BrightnessDataFe = this.getBrightnessFe
        let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
        let f2foot = f2l - this.selectedLensData.fe
        if (this.selectedModelData.lensExchange === true) {
          f2foot = f2l - BrightnessDataFe
        }
        this.isNegativeNum = (f2foot*10).toFixed(0) < 0
        return this.$commonJs.changeUnit(f2foot, this.graph.unit) + ' ' + this.unitLabel
      },
  
      getBrightnessFe () {
        let brightnessfe
        let lensExchange = this.selectedModelData.lensExchange
        if (lensExchange) {
          let code = this.selectedModelData.code
          let lensId = this.selectedLensData.id
          for (let i = 0; i < this.Brightness.optionLens.length; i++) {
            if (this.Brightness.optionLens[i].code === code && this.Brightness.optionLens[i].lensId === lensId) {
              brightnessfe = this.Brightness.optionLens[i].fe / 10
            }
          }
        }
        return brightnessfe
      },
  
      getBrightnessCc () {
        let brightnesscc
        let lensExchange = this.selectedModelData.lensExchange
        if (lensExchange) {
          let code = this.selectedModelData.code
          let lensId = this.selectedLensData.id
          for (let i = 0; i < this.Brightness.optionLens.length; i++) {
            if (this.Brightness.optionLens[i].code === code && this.Brightness.optionLens[i].lensId === lensId) {
              brightnesscc = this.Brightness.optionLens[i].cc / 10
            }
          }
        }
        return brightnesscc
      },
  
      getBrightnessMu () {
        let brightnessmu
        let lensExchange = this.selectedModelData.lensExchange
        if (lensExchange) {
          let code = this.selectedModelData.code
          let lensId = this.selectedLensData.id
          for (let i = 0; i < this.Brightness.optionLens.length; i++) {
            if (this.Brightness.optionLens[i].code === code && this.Brightness.optionLens[i].lensId === lensId) {
              brightnessmu = this.Brightness.optionLens[i].mu / 10
            }
          }
        }
        return brightnessmu
      },
  
      getBrightnessUp () {
        let brightnessup
        let lensExchange = this.selectedModelData.lensExchange
        if (lensExchange) {
          let code = this.selectedModelData.code
          let lensId = this.selectedLensData.id
          for (let i = 0; i < this.Brightness.optionLens.length; i++) {
            if (this.Brightness.optionLens[i].code === code && this.Brightness.optionLens[i].lensId === lensId) {
              brightnessup = this.Brightness.optionLens[i].up / 10
            }
          }
        }
        return brightnessup
      },
  
      getBrightnessLx () {
        let brightnesslx
        let lensExchange = this.selectedModelData.lensExchange
        if (lensExchange) {
          let code = this.selectedModelData.code
          let lensId = this.selectedLensData.id
          for (let i = 0; i < this.Brightness.optionLens.length; i++) {
            if (this.Brightness.optionLens[i].code === code && this.Brightness.optionLens[i].lensId === lensId) {
              brightnesslx = this.Brightness.optionLens[i].lx / 10
            }
          }
        }
        return brightnesslx
      },
  
      top2bottomProjector () {
        let BrightnessDataMu = this.getBrightnessMu
        let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
        if (this.selectedModelData.lensExchange === true) {
          let top2projector = Math.abs((f2l + BrightnessDataMu) - (this.graph.scrnH + this.floor2bottom))
          return this.$commonJs.changeUnit(top2projector, this.graph.unit) + ' ' + this.unitLabel
        } else {
          let top2projector = Math.abs((f2l + this.selectedLensData.mu) - (this.graph.scrnH + this.floor2bottom))
          return this.$commonJs.changeUnit(top2projector, this.graph.unit) + ' ' + this.unitLabel
        }
      },
  
      top2bottomProjectorLx () {
        let BrightnessDataMu = this.getBrightnessMu
        let BrightnessDataCc = this.getBrightnessCc
        let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
        if (this.selectedModelData.lensExchange === true) {
          let top2projectorlx = Math.abs((f2l + BrightnessDataCc + BrightnessDataMu) - (this.graph.scrnH + this.floor2bottom))
          return this.$commonJs.changeUnit(top2projectorlx, this.graph.unit) + ' ' + this.unitLabel
        } else {
          let top2projectorlx = Math.abs((f2l + BrightnessDataCc + this.selectedLensData.mu) - (this.graph.scrnH + this.floor2bottom))
          return this.$commonJs.changeUnit(top2projectorlx, this.graph.unit) + ' ' + this.unitLabel
        }
      },
  
      bottom2FootProjector () {
        let BrightnessDataFe = this.getBrightnessFe
        let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
        if (this.selectedModelData.lensExchange === true) {
          let b2footprojector = Math.abs((f2l - BrightnessDataFe) - this.floor2bottom)
          return this.$commonJs.changeUnit(b2footprojector, this.graph.unit) + ' ' + this.unitLabel
        } else {
          let b2footprojector = Math.abs((f2l - this.selectedLensData.fe) - this.floor2bottom)
          return this.$commonJs.changeUnit(b2footprojector, this.graph.unit) + ' ' + this.unitLabel
        }
      },
  
      floor2bottomCpmuted () {
        return this.$commonJs.changeUnit(this.floor2bottom, this.graph.unit) + ' ' + this.unitLabel
      },
  
      screenSizeComputed () {
        if ((this.vAngleFlag && this.vAngle !== 0) || (this.hAngleFlag && this.hAngle !== 0)) {
          if (this.dashFlag) {
            return (this.screenSize * 1).toFixed(2) + ' inch'
          } else {
            return '-'
          }
        } else {
          return (this.screenSize * 1).toFixed(2) + ' inch'
        }
      },
  
      vLensShiftNowData () {
        return this.graph.vLensShift.max === this.graph.vLensShift.min ? 'N/A' : this.vLensShiftNow.toFixed(0) + '%'
      },
  
      hLensShiftNowData () {
        return this.graph.hLensShift.max === this.graph.hLensShift.min ? 'N/A' : this.hLensShiftNow.toFixed(0) + '%'
      },
      frontWallUrl () {
        return this.isLatvia ? 'front_P2' : 'front_P1'
      }
    },
    watch: {
      graph: {
        handler (newValue, oldValue) {
          this.relativeBasePointer = ''
          this.relativeBasePointer = this.getRelativeBasePointer(newValue)
        },
        deep: true
      }
    }
  }
  </script>
  <style type="text/css">
  .information-right {
    width: 320px;
    height: 225.5px;
    background: #e3e3e3;
    margin: 10px 0;
  }
  .information-right-desk-lx-angle {
    background: url('../../assets/parts/result/result_desk_lx_angle.jpg') no-repeat;
    background-size: contain;
  }
  
  .information-right-desk-angle {
    background: url('../../assets/parts/result/result_desk_angle.jpg') no-repeat;
    background-size: contain;
  }
  
  .information-right-desk-lx {
    background: url('../../assets/parts/result/result_desk_lx.jpg') no-repeat;
    background-size: contain;
  }
  
  .information-right-desk {
    background: url('../../assets/parts/result/result_desk.jpg') no-repeat;
    background-size: contain;
  }
  
  .information-right-ceil {
    background: url('../../assets/parts/result/result_ceil.jpg') no-repeat;
    background-size: contain;
  }
  
  .information-right-ceil-lx {
    background: url('../../assets/parts/result/result_ceil_lx.jpg') no-repeat;
    background-size: contain;
  }
  
  .information-right-ceil-lx-angle {
    background: url('../../assets/parts/result/result_ceil_lx_angle.jpg') no-repeat;
    background-size: contain;
  }
  
  .information-right-ceil-angle {
    background: url('../../assets/parts/result/result_ceil_angle.jpg') no-repeat;
    background-size: contain;
  }
  
  .ust-information-right {
    width:320px;
    height: 210px;
  }
    .info-ul-dot{
      list-style: disc;
      padding-left: 20px !important;
    }
    .info-ul-dot li:first-child{
      margin-left:-20px
    }
    .negative_num_color{
      color: #ed843d;
    }
  </style>
  